webpackJsonp([221424569729900],{

/***/ 1406:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"CreateStockTransferRequestItemInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"productId","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"SCALAR","name":"ID","ofType":null}}},{"defaultValue":null,"description":null,"name":"requestedQuantity","type":{"kind":"SCALAR","name":"Decimal","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-create-stock-transfer-request-item-input-2ff688b09d04e0532e18.js